// B2B
const B2BDistributorId = 'H0095';
// 'O_B2B’ -- B2B발주총판
const O_B2B = [
    B2BDistributorId,
    'H0199',
    'H4202',
    'H0203',
];
// 'F_B2B' -- 재무그룹관리용
const F_B2B = [
    'H0290',
];
// 'R_B2B' -- 연구소관리용
const R_B2B = [
    'H0044',
];
// 'N_B2B' -- 넥서스
const N_B2B = [
    'H0240',
    'H0259',
];
// 'D_B2B' -- KT직영총판 (사용안함)
const D_B2B = [
    'H0142',
];
// 'M_B2B' -- 정산관리용
const M_B2B = [
    'H0057',
    'H0154',
    'H0213',
];
export default {
    B2BDistributorId,
    O_B2B,
    F_B2B,
    R_B2B,
    N_B2B,
    D_B2B,
    M_B2B,
};
